import React, { useContext, useEffect, useState } from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { Helmet } from 'react-helmet-async';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import Table from 'react-bootstrap/Table';
import { Store } from '../Store';
import axios from 'axios';
import { toast } from 'react-toastify';
import { getError } from '../utils';
import { api } from "../Api";


export default function RewardHistory() {
  const navigate = useNavigate();
  const { state } = useContext(Store);
  const { userInfo } = state;
  const { search } = useLocation();
  const sp = new URLSearchParams(search);
  const page = sp.get('page') || 1;
  const initData = [
    {
      from: '',
      to: 'Loading',
      amount: '',
      created: '',
    },
  ];

  const [totalUsers, setTotalUsers] = useState();
  const [totalPages, setTotalPages] = useState();
  const [history, setHistory] = useState(initData);
  const fetchData = async () => {
    try {
      const { data } = await axios.post(
        api + `/api/designation/rewardhistory?page=${page}`,
        {
          username: userInfo.username,
        },
        {
          headers: { Authorization: `Bearer ${userInfo.token}` },
        }
      );

      setHistory(data.products);
      setTotalPages(data.pages);
      setTotalUsers(data.countProducts);
    } catch (error) {
      toast.error(getError('Error from fetchData Catch: ' + error));
    }
  };

  const [des, setDes] = useState([]);
  async function getDesignation() {
    try {
      const { data } = await axios.get(
        api + `/api/designation/getdesignations`,
        {
          headers: { Authorization: `Bearer ${userInfo.token}` },
        }
      );
      setDes(data.designation);
    } catch (error) {
      toast.error('Error in getDesignation');
    }
  }

  useEffect(() => {
    getDesignation();
    fetchData();
  }, [page, userInfo]);

  function gotoHome() {
    navigate('/history');
  }

  function getReward(value) {
    for (let i = 0; i < des.length; i++) {
      if (des[i].name === value) {
        return des[i].reward;
      }
    }
  }

  return (
    <div>
      <Helmet>
        <title>Reward History </title>
      </Helmet>
      <Container className="no-gutter" style={{}}>
        <div className="card">
          <Row>
            <Col style={{ textAlign: 'center' }}>
              <img
                src="https://res.cloudinary.com/dddogyqqa/image/upload/v1670435815/logo/clickcart-logo_wfktlg.png"
                style={{ width: '15rem', margin: '2rem' }}
                alt="ClickCart Logo"
              />
            </Col>
          </Row>
          <div
            className="card-header"
            onClick={() => {
              gotoHome();
            }}
          >
            <i className="fa fa-long-arrow-left" aria-hidden="true"></i> {'  '}{' '}
            Reward History
          </div>
          <div className="card-body" style={{ margin: 'auto' }}></div>
          <Table
            responsive
            style={{ width: '95%', margin: 'auto' }}
            className="table-striped"
          >
            <thead className="table-light text-center">
              <tr>
                <th>Promotion</th>
                <th>Reward</th>
                <th>Date</th>
              </tr>
            </thead>
            <tbody>
              {history.map((product) => (
                <tr key={product._id}>
                  <td>{product.position_name}</td>
                  <td>{getReward(product.position_name)}</td>
                  <td>
                    {product.updated_at
                      ? product.updated_at.substring(0, 10)
                      : ''}
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>

          <nav aria-label="..." style={{ margin: '1rem' }}>
            <ul className="pagination">
              <Link
                className={
                  parseInt(page) - 2 < 1 ? 'page-link disabled' : 'page-link'
                }
                to={`/rewardhistory?page=${parseInt(page) - 2}`}
              >
                Previous
              </Link>
              <li className="page-item">
                <Link
                  className={
                    parseInt(page) - 1 < 1 ? 'page-link disabled' : 'page-link'
                  }
                  to={`/rewardhistory?page=${parseInt(page) - 1}`}
                >
                  {parseInt(page) - 1}
                </Link>
              </li>
              <li className="page-item active">
                <span className="page-link">
                  {parseInt(page)}
                  <span className="sr-only">(current)</span>
                </span>
              </li>
              <li className="page-item">
                <Link
                  className={
                    parseInt(page) + 1 > totalPages
                      ? 'page-link disabled'
                      : 'page-link'
                  }
                  to={`/rewardhistory?page=${parseInt(page) + 1}`}
                >
                  {parseInt(page) + 1}
                </Link>
              </li>
              <li className="page-item">
                <Link
                  className={
                    parseInt(page) + 2 > totalPages
                      ? 'page-link disabled'
                      : 'page-link'
                  }
                  to={`/rewardhistory?page=${page + 2}`}
                >
                  Next
                </Link>
              </li>
            </ul>
          </nav>
          <div style={{ height: '51vh' }}> {''}</div>
        </div>
      </Container>
    </div>
  );
}
